import { forgetM365CopilotSignIns } from "./m365Auth";

/** Every chat, credential, token and conversation the assistant keeps is stored under this. */
const AI_KEY_PREFIX = "onetasklist.ai.";

function removeAiKeys(storage: Storage) {
  try {
    const keys = Array.from({ length: storage.length }, (_, i) => storage.key(i));
    for (const key of keys) {
      if (key?.startsWith(AI_KEY_PREFIX)) storage.removeItem(key);
    }
  } catch {
    // Storage that can't be read holds nothing to clear.
  }
}

/**
 * Forgets everything the AI assistant keeps in this browser: kept chats, provider credentials,
 * Copilot's tokens, conversations and MSAL sign-in. Chats hold board content and Copilot answers
 * drawn from mail and meetings, so on sign-out none of it may be left for the next person. The
 * panel's width and open state are preferences, not data, and stay. Never throws: sign-out must
 * go ahead whatever this manages.
 */
export async function clearAiDataOnDevice(): Promise<void> {
  // First, while the keys that say which Copilot registrations this tab used still exist.
  try {
    await forgetM365CopilotSignIns();
  } catch {
    // The MSAL cache is in sessionStorage and goes when the tab closes.
  }
  removeAiKeys(localStorage);
  removeAiKeys(sessionStorage);
}
